var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "h-166 flex row-between col-center m-b-12" }, [
      _c(
        "div",
        {
          staticClass: "width-32 height-100 flex-col row-center col-center",
          style: _vm.getBackgroundStyle(_vm.ssjeUrl),
        },
        [
          _c("div", { staticClass: "font-36 font-weight-700 m-b-20" }, [
            _vm._v(_vm._s(_vm.statisticsData?.receivedAmount)),
            _c("span", { staticClass: "font-16" }, [_vm._v(" 万元")]),
          ]),
          _c("div", { staticClass: "font-24" }, [_vm._v("实收金额")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "width-32 height-100 flex-col row-center col-center",
          style: _vm.getBackgroundStyle(_vm.zcjeUrl),
        },
        [
          _c("div", { staticClass: "font-36 font-weight-700 m-b-20" }, [
            _vm._v(_vm._s(_vm.statisticsData?.expenseAmount)),
            _c("span", { staticClass: "font-16" }, [_vm._v(" 万元")]),
          ]),
          _c("div", { staticClass: "font-24 m-b-2" }, [_vm._v("支出金额")]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "width-32 height-100 flex-col row-center col-center",
          style: _vm.getBackgroundStyle(_vm.zlrUrl),
        },
        [
          _c("div", { staticClass: "font-36 font-weight-700 m-b-20" }, [
            _vm._v(_vm._s(_vm.statisticsData?.profitTotal)),
            _c("span", { staticClass: "font-16" }, [_vm._v(" 万元")]),
          ]),
          _c("div", { staticClass: "font-24" }, [_vm._v("总利润")]),
        ]
      ),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("业务单元利润分布"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "p-16" },
        _vm._l(_vm.statisticsData?.profitList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "flex col-center row-between p-t-18 p-b-18",
              staticStyle: { "border-bottom": "1px solid #d4d5de" },
            },
            [
              _c("div", { staticClass: "flex col-center" }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: index == 0,
                      expression: "index == 0",
                    },
                  ],
                  staticClass: "w-34 h-34 m-r-16",
                  attrs: {
                    alt: "rank",
                    src: require("@/assets/icon/operateKanban/rank1.png"),
                  },
                }),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: index == 1,
                      expression: "index == 1",
                    },
                  ],
                  staticClass: "w-34 h-34 m-r-16",
                  attrs: {
                    alt: "rank",
                    src: require("@/assets/icon/operateKanban/rank2.png"),
                  },
                }),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: index == 2,
                      expression: "index == 2",
                    },
                  ],
                  staticClass: "w-34 h-34 m-r-16",
                  attrs: {
                    alt: "rank",
                    src: require("@/assets/icon/operateKanban/rank3.png"),
                  },
                }),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: index > 2,
                        expression: "index > 2",
                      },
                    ],
                    staticClass:
                      "dis-in-b text-center w-34 h-34 font-28 cor-66 m-r-16",
                  },
                  [_vm._v(_vm._s(index + 1))]
                ),
                _c("span", { staticClass: "font-28" }, [
                  _vm._v(_vm._s(item.unitName)),
                ]),
              ]),
              _c("div", { staticClass: "width-35 flex col-center" }, [
                _c("img", {
                  staticClass: "w-36 h-36 m-r-20",
                  attrs: {
                    alt: "currency",
                    src: require("@/assets/icon/operateKanban/money.png"),
                  },
                }),
                _c("span", { staticClass: "font-28" }, [
                  _vm._v(_vm._s(item.profitAmount) + " 万元"),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("年度经营指标完成情况"),
          ]),
        ],
        1
      ),
      _c("div", [
        _c(
          "div",
          { staticClass: "flex col-center row-right m-t-12 m-b-12" },
          _vm._l(_vm.jyzbSelectList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "font-28 h-56 l-h-56 p-l-14 p-r-14 bg-D9D9D9 cor-99 m-l-20 b-r-8",
                class: { active: _vm.jyzbActiveIndex === index },
                on: {
                  click: function ($event) {
                    return _vm.clickOneSelect(index, "jyzb")
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.name) + " ")]
            )
          }),
          0
        ),
        _c("div", {
          ref: "jyzbBar",
          staticStyle: { width: "90vw", height: "280px" },
          attrs: { id: "jyzbBar" },
        }),
      ]),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("近3年经营分析"),
          ]),
        ],
        1
      ),
      _c("div", [
        _c(
          "div",
          { staticClass: "flex col-center row-right m-t-12 m-b-12" },
          _vm._l(_vm.jyfxSelectList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "font-28 h-56 l-h-56 p-l-14 p-r-14 bg-D9D9D9 cor-99 m-l-20 b-r-8",
                class: { active: _vm.jyfxActiveIndex === index },
                on: {
                  click: function ($event) {
                    return _vm.clickOneSelect(index, "jyfx")
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.name) + " ")]
            )
          }),
          0
        ),
        _c("div", {
          ref: "jyfxLine",
          staticStyle: { width: "90vw", height: "280px" },
          attrs: { id: "jyfxLine" },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }